// Main js file for the object
function collection() {
  console.log('collection');
}

export default collection;
